import { FC } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Organization } from "../../../shared/models/organization.model";

interface Props {
  organizationForm: Organization;
  setOrganizationForm: any;
  updateOrg: () => Promise<void>;
}

const OrganizationGeneralTab: FC<Props> = ({
  organizationForm,
  setOrganizationForm,
  updateOrg,
}) => {
  return (
    <div>
      <div className="mb-4">
        <h5 className="mb-1">General Information</h5>
        <p className="text-muted small mb-0">Basic details about this organization</p>
      </div>

      <Form>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Organization Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                value={organizationForm.name}
                onChange={(e) => {
                  setOrganizationForm((prev: any) => ({
                    ...prev,
                    name: e.target.value,
                  }));
                }}
                placeholder="Enter organization name"
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Short Name</Form.Label>
              <Form.Control
                type="text"
                value={organizationForm.short_name || ""}
                onChange={(e) => {
                  setOrganizationForm((prev: any) => ({
                    ...prev,
                    short_name: e.target.value,
                  }));
                }}
                placeholder="Enter short name"
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Website URL</Form.Label>
              <Form.Control
                type="url"
                value={organizationForm.site_url || ""}
                onChange={(e) => {
                  setOrganizationForm((prev: any) => ({
                    ...prev,
                    site_url: e.target.value,
                  }));
                }}
                placeholder="https://example.com"
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-4">
          <Form.Label className="fw-semibold">Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={organizationForm.description}
            onChange={(e) => {
              setOrganizationForm((prev: any) => ({
                ...prev,
                description: e.target.value,
              }));
            }}
            placeholder="Brief description of the organization"
          />
          <Form.Text className="text-muted">
            This description helps identify the organization's purpose
          </Form.Text>
        </Form.Group>

        <div className="d-flex justify-content-end pt-3 border-top">
          <Button variant="primary" onClick={updateOrg} className="px-4">
            <i className="bi bi-check-circle me-2"></i>
            Save Changes
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default OrganizationGeneralTab;